 <template>
<router-link :title="this.$root.trans.back" class="btn btn-danger pull-right mb-10" :to="{name: routeName}"><i class="ti-close"></i></router-link>    
</template>

<script>
    import baseApi from '@/baseApi'
    export default {
        components: {
        },
        props: {
            routeName: String,
        },
        data () {
            return {
            }
        },
        computed:{
        },
        mounted() {
			
        },
        methods: {
         
		},
        watch: {
            
        },
    }
</script>




